<template>
    <div>
        <span
            v-for="i in 5"
            :key="i"
            :style="{ height, width: width }"
            class="SkeletonBox"
        />
    </div>
</template>

<script>
export default {
    name: 'ContantTableLoading',
    props: {
        height: {
            // Make lines the same height as text.
            default: '31px',
            type: String
        },
        width: {
            // Make it possible to define a fixed
            // width instead of using a random one.
            default: 'calc(100% - 20px)',
            type: String
        }
    }
}
</script>

<style scoped lang="scss">
.SkeletonBox {
    display: inline-block;
    position: relative;
    overflow: hidden;
    vertical-align: middle;
    background-color: #DDDBDD;
    margin: 10px;
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: translateX(-100%);
      background-image: linear-gradient(
        90deg,
        rgba(#fff, 0) 0,
        rgba(#fff, 0.2) 20%,
        rgba(#fff, 0.5) 60%,
        rgba(#fff, 0)
      );
      animation: shimmer 1s infinite;
      content: '';
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
}
</style>
